// extracted by mini-css-extract-plugin
module.exports = {"scorecard-button":"styles-module__scorecard-button___d3voI"};